import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { EmployeesTopGroupsLoadAction } from '../../domains/employeesTopGroups/actions.types';

import { EmployeesTopGroupsLifecycle } from './types';

const initialState: EmployeesTopGroupsLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<EmployeesTopGroupsLifecycle, EmployeesTopGroupsLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'EMPLOYEES_TOP_GROUPS.LOAD_PENDING':
      return setPending();
    case 'EMPLOYEES_TOP_GROUPS.LOAD_FULFILLED':
      return setFulfilled(action.payload);
    case 'EMPLOYEES_TOP_GROUPS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
